import { openUrlInNewTabWhileTwilioCallIsActive } from './twilio-common.js';

(function () {
  let workerAttributes = {};
  let workerIsAvailable = false;

  function listenInit(callback) {
    TourlaneFlex.addEventListener('init', function (payload) {
      // Fired only once the widget is loaded.
      $('#loader-icon').removeClass('fa-spin');
      callback(payload.workerAttributes);
    });
  }

  function listenActivityChange() {
    // Need to listen to two events for full syncronization.
    TourlaneFlex.addEventListener('afterSetActivity', function (payload) {
      // Called when widget loads and everytime activity is changed using the menu in the widget.
      workerIsAvailable = payload.name === TWILIO_ACTIVITY_AVAILABLE;
      updateActivityIndicator();
    });

    TourlaneFlex.addEventListener('workerActivityUpdated', function (activity) {
      // Not called when the widget loads first. But everytime the activity is changed even from outside the widget.
      workerIsAvailable = activity.available;
      updateActivityIndicator();
    });

    TourlaneFlex.addEventListener('workerAttributesUpdated', function (wrkAttrs) {
      workerAttributes = wrkAttrs;
      updateActivityIndicator();
    });
  }

  function updateActivityIndicator() {
    const { presales_only, presales_auto_dialer } = workerAttributes;
    if (workerIsAvailable && presales_only && presales_auto_dialer) {
      $('#activity-indicator').removeClass('text-danger').addClass('text-success').html("You're available! 👌");
    } else {
      if (workerIsAvailable) {
        $('#activity-indicator').removeClass('text-success').addClass('text-danger').html("<p>You're available but not taking part in auto dialing.</p>");
      } else {
        $('#activity-indicator').removeClass('text-success').addClass('text-danger').html("<p>You're not available! 😴</p>");
      }
    }
  }

  function updateMicroPermissionIndicator(permitted) {
    if (permitted) {
      $('#micro-permission-indicator').removeClass('text-danger').html("");
    } else {
      $('#micro-permission-indicator').addClass('text-danger').html("<p>⚠️ ⚠️ ⚠️  Missing permission to use microphone! Please permit your browser to access your microphone. ⚠️ ⚠️ ⚠️ </p>");
    }
  }

  function updatePopupPermissionIndicator(permitted) {
    if (permitted) {
      $('#popup-permission-indicator').removeClass('text-danger').html("");
    } else {
      $('#popup-permission-indicator').addClass('text-danger').html("<p>⚠️ ⚠️ ⚠️  Unable to open popups! Please permit your browser to open popups. ⚠️ ⚠️ ⚠️ </p>");
    }
  }

  function checkMicroPermissions() {
    navigator.permissions.query({ name: 'microphone' }).then(function (permissionStatus) {
      if (permissionStatus.state !== 'granted') {
        TourlaneFlex.setActivityStatus(TWILIO_ACTIVITY_OFFLINE);
      }
      updateMicroPermissionIndicator(permissionStatus.state === 'granted')

      permissionStatus.onchange = function () {
        if (this.state !== 'granted') {
          TourlaneFlex.setActivityStatus(TWILIO_ACTIVITY_OFFLINE);
        }
        updateMicroPermissionIndicator(this.state === 'granted')
      }
    })
  }

  function checkPopupPermissions() {
    const testPopup = window.open('', '_blank', 'width=100,height=100');

    if (testPopup) {
      testPopup.close();
      updatePopupPermissionIndicator(true);
    } else {
      TourlaneFlex.setActivityStatus(TWILIO_ACTIVITY_OFFLINE);
      updatePopupPermissionIndicator(false);
    }
  }

  function listenReservationAccepted() {
    TourlaneFlex.addEventListener('reservationAccepted', function (reservation) {
      // This code runs when the call starts.

      const url = reservation.taskAttributes?.call_web_context?.url
      // If we accepted a task with `call_web_context`, open the `call_web_context.url` in a new tab.
      // The `call_web_context` is set when the Auto Dialer creates a call.

      if (url) {
        openUrlInNewTabWhileTwilioCallIsActive(url)
      }

    });
  }

  window.addEventListener('DOMContentLoaded', () => {
    const isAutoDialerPage = document.querySelector('meta[name="current_page"]')?.content === 'auto_dialer'
    if (!isAutoDialerPage) {
      return
    }

    TourlaneSuite.showFlexIframe();

    const afterListen = (wrkAttrs) => {
      TourlaneFlex.setActivityStatus(TWILIO_ACTIVITY_AVAILABLE);
      checkMicroPermissions();
      checkPopupPermissions();
      workerAttributes = wrkAttrs;

      const req = () => {
        $.ajax({
          url: '/qualification/auto_dialer/stats',
          method: 'GET',
          success: function (data) {
            $('#active-calls .calls').html(data.active_calls);
            window.setTimeout(req, 5000);
          }
        });
      }

      req();
    };

    listenInit(afterListen);
    listenActivityChange();
    listenReservationAccepted();
  });
})();
